import { render, staticRenderFns } from "./viewLFSIS.vue?vue&type=template&id=47cecb21&scoped=true"
import script from "./viewLFSIS.vue?vue&type=script&lang=js"
export * from "./viewLFSIS.vue?vue&type=script&lang=js"
import style0 from "./viewLFSIS.vue?vue&type=style&index=0&id=47cecb21&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cecb21",
  null
  
)

export default component.exports